export default __webpack_public_path__ + "static/media/css.4a6549b8.png";